import DashboardLayout from './dashboardLayout.js';

export default DashboardLayout;
